module.exports = __webpack_public_path__ + "static/media/AdobeSign_Step1_Image18a.62aa0075.webp";